import {
  Banner,
  HomeContent,
  ContactUs,
  CelebrityTraining,
  Testimonial
  // Bootcamps
} from '../container';

import AboutUs from '../container/AboutUs/AboutUs';
import Services from '../container/Services/Services';

const Home = () => {
  return (
    <>
      <Banner />
      <HomeContent />
      <AboutUs />
      <CelebrityTraining />
      <Services />
      <Testimonial />
      {/* <Bootcamps /> */}
      <ContactUs />
    </>
  );
};

export default Home;
